import React from 'react'

import { useQuery } from '@apollo/client'
import { cloneDeep } from 'lodash/lang'

import query from './query.graphql'

const withQuery = WrappedComponent => {
  return props => {
    const {
      pickupPersonId, // via withParams
      setPickupPersonForm, // via redux actions
      setErrorMessage, // via redux actions
      onQueryError, // via withQueryResults
      onLoggedInQueryCompleted // via withQueryResults
    } = props

    // react hooks
    const {
      loading: queryLoading,
      error: queryError,
      data: queryData
    } = useQuery(query, {
      variables: { pickupPersonId },
      onError: onQueryError,
      onCompleted: data => handleQueryCompleted(data)
    })

    const handleQueryCompleted = data => {
      if (!onLoggedInQueryCompleted(data)) {
        return
      }

      if (data && data.viewer) {
        const pickupPerson = data.viewer.pickupPeople[0]

        if (!pickupPerson) {
          setErrorMessage('The pick-up person was not found')
          return
        }

        setPickupPersonForm(cloneDeep(pickupPerson))
      }
    }

    // GraphQL data
    const { viewer: account, seasons } = queryData || {}
    const pickupPerson = account ? account.pickupPeople[0] : null
    const season = seasons ? seasons[0] : null

    return (
      <WrappedComponent
        queryLoading={queryLoading}
        queryError={queryError}
        pickupPerson={pickupPerson}
        account={account}
        season={season}
        {...props}
      />
    )
  }
}

export default withQuery
